import { render, staticRenderFns } from "./ContentForGnbPmDataQueryRightList.vue?vue&type=template&id=470f4084&scoped=true&"
import script from "./ContentForGnbPmDataQueryRightList.vue?vue&type=script&lang=js&"
export * from "./ContentForGnbPmDataQueryRightList.vue?vue&type=script&lang=js&"
import style0 from "./ContentForGnbPmDataQueryRightList.vue?vue&type=style&index=0&id=470f4084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f4084",
  null
  
)

export default component.exports